import { render, staticRenderFns } from "./AttachmentLayout.vue?vue&type=template&id=2fc58f6e"
import script from "./AttachmentLayout.vue?vue&type=script&lang=js"
export * from "./AttachmentLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports